import React from 'react';
import { Tag } from 'antd';
import dayjs from 'dayjs';

// Status mapping for display
export const STATUS_MAP = {
  'CREATED': '已创建',
  'PRINTED': '已打印',
  'DUPLICATE': '重复订单',
  'SHIPPING': '运输中',
  'PENDING_REVIEW': '未审单',
  'PENDING_CUSTOMS': '待清关',
  'PICKED_UP': '已提货未过机',
  'INSPECTED_PENDING': '已出查验未放行',
  'RELEASED': '已放行',
  'DELIVERING': '派送中',
  'DELIVERED': '已送达',
};

/**
 * Get the human-readable label for a status code
 * @param {string} status - The status code
 * @returns {string} The human-readable status label
 */
export const getStatusLabel = (status) => STATUS_MAP[status] || status;

/**
 * Get the appropriate color for a status tag
 * @param {string} status - The status code
 * @returns {string} The color name for the tag
 */
export const getStatusColor = (status) => {
  const label = STATUS_MAP[status] || status;
  switch (label) {
    case '重复订单':
      return 'orange';
    case '运输中':
        return 'processing';
    case '未审单':
      return 'warning';
    case '待清关':
      return 'warning';
    case '已提货未过机':
      return 'processing';
    case '已出查验未放行':
      return 'error';
    case '已放行':
      return 'success';
    case '派送中':
      return 'processing';
    case '已送达':
      return 'success';
    default:
      return 'default';
  }
};

/**
 * Render a status tag with appropriate color
 * @param {string} status - The status code
 * @returns {JSX.Element} The rendered status tag
 */
export const renderStatusTag = (status) => (
  <Tag 
    style={{ padding: '0 4px', fontSize: '12px', margin: 0 }} 
    color={getStatusColor(status)}
  >
    {getStatusLabel(status)}
  </Tag>
);

/**
 * Format a date string to a standard format
 * @param {string} dateString - The date string to format
 * @returns {string} The formatted date string
 */
export const formatDate = (dateString) => {
  return dayjs(dateString).format('YYYY-MM-DD');
};
